const uniFetch = fetch;

export default uniFetch;
